import React from "react";

/**
 * Subtle binary "01" pattern fixed behind page content.
 * Visible near the edges, fades to (almost) invisible in the center via radial mask.
 * Very low opacity, navy tone — feels like a tech hint, not decoration.
 */
export const BinaryBackdrop = () => {
  return (
    <div
      aria-hidden="true"
      className="bp-binary-bg"
      data-testid="binary-backdrop"
    />
  );
};

export default BinaryBackdrop;
